'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { getENV } from '../../utils/env';
export const AdyenDataCollectionLegacy = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="adyen-data-collection-sdk" src={getENV("NEXT_PUBLIC_ADYEN_DATA_COLLECTION_SDK_SCRIPT_URL")} async={true} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};